const btnTriggerAuth = document.querySelector('[data-trigger-member]');

interface Post {
    postId: string;
    title: string;
}

interface Member {
    memberId: string;
    name: string;
    email: string;
    role: string;
    posts: Post[];
}

const getMemberDetail = async(): Promise<void> => {
    try {
        const getMember = await fetch('/assets/data/member.json', {
            method: 'GET',
            credentials: 'include',
        });

        if (!getMember.ok) {
            throw new Error('Error request data to server');
        }

        const member: Member = await getMember.json();

        const elMemberId = document.getElementById('memberId');
        const elMemberName = document.getElementById('memberName');
        const elMemberEmail = document.getElementById('memberEmail');
        const elMemberRole = document.getElementById('memberRole');
        const elMemberPosts = document.getElementById('memberArticle');

        if (elMemberId) {
            elMemberId.textContent = member.memberId;
        }
        if (elMemberName) {
            elMemberName.textContent = member.name;
        }
        if (elMemberEmail) {
            elMemberEmail.textContent = member.email;
        }
        if (elMemberRole) {
            elMemberRole.textContent = member.role;
        }

        if (elMemberPosts) {
            let memberPosts = '';

            if (member.posts.length) {
                member.posts.forEach(post => {
                    memberPosts += `<li>${post.title}</li>`;
                });
            }
            elMemberPosts.innerHTML = `<h4>Recommended articles</h4><ul>${memberPosts}</ul>`;
        }
    } catch (error) {
        console.error(error);
    }
};

if (btnTriggerAuth) {
    btnTriggerAuth.addEventListener('click', async ev => {
        ev.preventDefault();

        await getMemberDetail();
    });
}
